import React from 'react'
import amdImg from '../../../../assets/admimg.jpg'
import { Button, LinearProgress } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserStorage } from '../../../../storage/user';
import './styles.css'
import { useCursosStorage } from '../../../../storage/cursos';

export default function CursosView() {

    const { cursosTotais } = useCursosStorage(state => state).dados
    
    return (
        <div style={{ padding: '20px' }}>
            <h2 style={{ margin: '0 0 20px 0' }}>Curso Em Progresso  </h2>
            <div className='cursoDiv'>
                { cursosTotais?.length !== 0 && cursosTotais?.map(item => {
                        return (
                            <CardCurso star={4.56} title={item.titulo} id={item.id} aulasFeitas={1} aulasTotal={27} imagem={item.imagem} />
                        )
                    })
                }
            </div>

        </div>
    )
}

function CardCurso({ star, aulasFeitas, aulasTotal, title, id, imagem }) {

    const navigate = useNavigate();

    return (
        <div style={{ width: '250px', height: '260px', borderRadius: '10px', border: '1px solid #ddd', margin: '10px' /* display: 'flex', alignItems: 'center'  */ }}>
            <img src={imagem} style={{ width: '250px', height: '150px', borderRadius: '10px 10px 0 0' }} />
            <div style={{ padding: '10px' }}>
                <h4 style={{ color: '#333', textAlign: 'center', marginBottom: '20px' }}><b>{title}</b></h4>

                {/* <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
                    <h5>1/29</h5>
                    <h5>3% Completo</h5>
                </div>
                <LinearProgress variant="determinate" value={90} style={{ marginBottom: '20px' }} /> */}
                <button onClick={() => { navigate(`/cursos/${id}`) }} className='completo'> Curso completo</button>
            </div>
        </div>
    )
}
